import React, { useEffect, useState } from "react";
import { Stepper, Step, StepLabel, Box, Typography } from "@mui/material";
import { StepConnector, stepConnectorClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

const steps = ["Personal Info", "Medical Info", "Checkout"];

const BackArrow = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.46967 6.16998C0.176777 5.87709 0.176777 5.40221 0.46967 5.10932L5.24264 0.336348C5.53553 0.0434546 6.01041 0.0434546 6.3033 0.336348C6.59619 0.629241 6.59619 1.10411 6.3033 1.39701L2.06066 5.63965L6.3033 9.88229C6.59619 10.1752 6.59619 10.6501 6.3033 10.9429C6.01041 11.2358 5.53553 11.2358 5.24264 10.9429L0.46967 6.16998ZM11 6.38965L1 6.38965L1 4.88965L11 4.88965L11 6.38965Z"
        fill="#C0C0C0"
      />
    </svg>
  );
};

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 15,
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderTop: "2px dashed #D7D7D7",
  },
}));

const CustomStepper = ({
  activeStep,
  onBack,
}: {
  activeStep: number;
  onBack: () => void;
}) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 600);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 600);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
      }}
    >
      {isDesktop && onBack && (
        <button
          className="arrow-btn"
          onClick={onBack}
          style={{
            position: "absolute",
            left: 0,
            top: "25%",
            transform: "translateY(-50%)",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            touchAction: "manipulation",
            zIndex: 5,
          }}
        >
          <BackArrow />
        </button>
      )}
      <Stepper
        nonLinear
        activeStep={activeStep}
        alternativeLabel
        connector={<CustomStepConnector />}
        sx={{ width: "100%", maxWidth: "500px" }} // adjust width as needed
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={({ active }) => (
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    backgroundColor: active ? "#894395" : "#E0E0E0",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "IBM Plex Sans",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  {index + 1}
                </Box>
              )}
            >
              <Typography
                sx={{
                  mt: 1,
                  fontFamily: "IBM Plex Sans",
                  fontSize: window.innerWidth < 600 ? "12px" : "14px",
                  fontWeight: 500,
                  color:
                    activeStep === index ? "#000000" : "rgba(0, 0, 0, 0.5)",
                  textAlign: "center",
                }}
              >
                {label}
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default CustomStepper;
